import styled from 'styled-components';

import { theme } from '@styles/theme';

// So we can use the transparent backgrounds
// without content behind showing through
export const BackgroundOverlay = styled.div({
  position: 'absolute',
  backgroundColor: theme.color.backgroundLightDark,
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: -1,
  borderRadius: 'inherit',
});
